import React, { PureComponent } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

class TooltipBase extends PureComponent {
  popperRef = React.createRef();

  state = {
    open: false,
  };

  handleTooltipClose = () => {
    this.setState({ open: false });
  };

  handleTooltipOpen = () => {
    this.setState({ open: true }, () => {
      if (this.popperRef && this.popperRef.current) {
        this.popperRef.current.popper.scheduleUpdate();
      }
    });
  };

  render() {
    const { children, title, className, placement } = this.props;
    return (
      <div className={`tooltip-base-container ${className ? className : ''}`} onClick={e => e.preventDefault()}>
        <ClickAwayListener onTouchStart={this.handleTooltipClose} onClickAway={this.handleTooltipClose}>
          <div>
            <Tooltip
              PopperProps={{
                disablePortal: true,
                ref: this.popperRef,
                className: 'tooltip-base-popper',
              }}
              onClose={this.handleTooltipClose}
              open={this.state.open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={title}
              placement={placement}>
              <div onClick={this.handleTooltipOpen}>{children}</div>
            </Tooltip>
          </div>
        </ClickAwayListener>
      </div>
    );
  }
}

export default TooltipBase;
